import React from "react";
import CheckList from "./components/CheckList";

function App() {
  return (
    <div className="bg-white min-h-screen w-full pt-20">
      <CheckList />
    </div>
  );
}

export default App;
